$(document).ready(function () {
  expandAcc();
  setPColumnCenter();

  // let resizeTimeout;
  // $(window).on('resize', function () {
  //   clearTimeout(resizeTimeout);
  //   resizeTimeout = setTimeout(function () {
  //     setPColumnCenter();
  //   }, 300);
  // });
});

function setPColumnCenter() {
  const $wrapper = $('.productcolumns_wrap');
  const $activeCard = $wrapper.find('.productcolumn_content__wrapper.has_tag_wrap').eq(0);

  if ($activeCard.length) {
    const wrapperWidth = $wrapper.width();
    const cardOffset = $activeCard.position().left;
    const scrollPos = cardOffset - (wrapperWidth / 2) + ($activeCard.outerWidth() / 2);

    $wrapper.animate({
      scrollLeft: scrollPos
    }, 0);
  }
}


$(document).on('click', '.acc_title-js', function () {
    const $wrapper = $(this).closest('.accordion_wrapper-js');
    $wrapper.toggleClass('desk_open mob_open');
    expandAcc();
});

$(document).on('submit', '.cusotm_atc_form', function (e) {
  const $form = $(this),
      $btn_wrp = $form.find('.product-form--button-container'),
      $btn = $form.find('.product-form--add-to-cart');
  $btn_wrp.attr("data-loading", true);
  try {
    e.preventDefault();
    theme.partials.Cart.addItem(
      $form,
      function (success, error) {
        $btn_wrp.attr("data-loading", false);
        if (success) {
          theme.partials.Cart.updateAllHtml(function () {
            if (theme.partials.OffCanvas.state === "closed") {
              theme.partials.OffCanvas.openRight();
            }
          });
        } else {
          $form.find(".product--error").remove();
          var product_error_el = theme.utils.parseHtml(
            "<div class='product--error' data-item='small-text'>" +
              error +
              "</div>",
            ".product--error"
          );
          $form.find(".product--details-container").append(product_error_el);
        }

        theme.window.trigger("resize");
      }
    );
  } catch (err) {
    console.error("Add to cart error:", err);
    $btn_wrp.attr("data-loading", false);
  }
});


function expandAcc() {
    const isDesktop = $(window).width() > 767;
    const activeClass = isDesktop ? 'desk_open' : 'mob_open';

    $('.accordion_wrapper-js').each(function () {
        const $el = $(this);
        const $content = $el.find('.acc_content-js');

        if ($el.hasClass(activeClass)) {
            $content.stop(true, true).slideDown();
        } else {
            $content.stop(true, true).slideUp();
        }
    });
}
